<div class="main">
  <app-menu *ngIf="!noMenu"></app-menu>
  <app-header></app-header>
  <div class="container">
    <div class="content">
      <ng-content></ng-content>
    </div>
    <app-footer></app-footer>
  </div>
</div>
